import type { ErrorStrategy } from '../types';

export const additionalPropertiesStrategy: ErrorStrategy = ({
  instancePath,
  params: { additionalProperty },
}) => ({
  path: `${instancePath}/${additionalProperty}`,
  message: `Mismatch between schema and form value names. ${additionalProperty} is not defined in the schema.`,
});
